const e=(e,r,n)=>{const t=[e];if(!r&&n)throw new Error("The element argument is required");return r&&t.push(`__${r}`),n&&t.push(`--${n}`),t.join("")};export{e as getBEMClassName};
//# sourceMappingURL=css.helpers.js.map
